import React from 'react';
import ReactDOM from 'react-dom';
import BranchBanner from './components/BranchBanner';
import { get as getQueryParamValue } from 'modules/query-params';

const $body = window.document.body;
const session = window.sessionStorage;
const assets = window.Raise.data.mobile && window.Raise.data.mobile.banner || undefined;
const defaultSlug = 'no-attrib';
const sessionKeys = {
  CLOSED_BANNER: '_bbclosed',
  BRANCH_CAMPAIGN_KEY: '_bc',
};
const duration = '100ms';
const easing = 'ease-out';
const bodyTransition = `margin ${duration} ${easing}`;
const branchActiveClass = 'branch-banner-is-active';
const bannerHeight = 76;

const bodyShiftDown = () => {
  $body.className += ` ${branchActiveClass}`;
  $body.style.transition = bodyTransition;
  $body.style.marginTop = `${bannerHeight}px`;
};

const bodyShiftUp = () => {
  const activeClassRegx = new RegExp(` ${branchActiveClass}`, 'g');
  $body.className = $body.className.replace(activeClassRegx, '');
  $body.style.marginTop = '';
};

const campaignSlugFromQueryParams = () => {
  return getQueryParamValue(sessionKeys.BRANCH_CAMPAIGN_KEY);
};

const campaignSlugFromSession = () => {
  return session.getItem(sessionKeys.BRANCH_CAMPAIGN_KEY);
};

const badgeClicked = () => {
  const campaignSlug = campaignSlugFromQueryParams() || campaignSlugFromSession();
  const slug = campaignSlug || defaultSlug;
  const link = assets && assets.use_branchio_direct && '//bnc.lt/m/OJjyA6DDeu' || `//geta.raise.com/${slug}`;
  window.location = link;
};

const isAndroidOrIOS = () => {
  const userAgent = window.navigator.userAgent;
  const match = userAgent.match(/iP(hone|od|ad)|Android/);
  if (match && match[0].indexOf('iP') === 0) {
    return 'ios';
  } else if (match) {
    return 'android';
  }
  return !!match;
};

const saveUserClosedBanner = () => {
  session.setItem(sessionKeys.CLOSED_BANNER, true);
};

const onClose = () => {
  saveUserClosedBanner();
  bodyShiftUp();
};

const saveCampaignSlug = (slug) => {
  if (slug) {
    session.setItem(sessionKeys.BRANCH_CAMPAIGN_KEY, slug);
  }
};

const userDidCloseBanner = () => {
  return !!session.getItem(sessionKeys.CLOSED_BANNER);
};

export default {
  init: () => {
    const androidOrIOS = isAndroidOrIOS();

    if (!assets || userDidCloseBanner() || !androidOrIOS) return;
    saveCampaignSlug(campaignSlugFromQueryParams());

    const $branch = document.getElementById('react-branchbanner-container');
    const badgeUrl = assets.badge[androidOrIOS];
    const bannerProps = {
      deviceType: androidOrIOS,
      duration,
      easing,
      iconUrl: assets.icon,
      badgeUrl,
      onClick: badgeClicked,
      onClose,
    };
    const branch = <BranchBanner { ...bannerProps } />;

    if ($branch) {
      setTimeout(bodyShiftDown, 0);
      ReactDOM.render(branch, $branch);
    }
  },
};
